import * as actions from '../../actions/actionTypes';
//
const initialState = true;
//
export default function last(state = initialState, action) {
  switch (action.type) {
    // SET_CHANNEL_CHANNEL
    case actions.SET_CHANNEL_CHANNEL:
      if (typeof action.payload.last !== 'undefined') {
        return action.payload.last;
      } else {
        return state;
      }
    default:
      return state;
  }
}
